<template>
    <div class="otp-inline-table" :class="tableHeight > 0 ? 'opt-table-with-table-height' : '' ">
        <el-table
            ref="moduleTable"
            border
            tooltip-effect='dark'
            v-loading="loading"
            :height="tableHeight > 0 ? tableHeight : tableConfig.height"
            :style="`height: ${tableHeight}px`"
            :data="tableData"
            :row-class-name="tableRowClassName"
            :row-key="getRowKeys"
            @selection-change="handleSelectionChange"
            @row-click='rowClick'
            @header-dragend="headerDragendHandler"
            @row-dblclick="rowDBclick">
            <el-table-column
                v-if="tableConfig.selectBtn"
                :reserve-selection="tableConfig.reserveSelection"
                type="selection"
                width="40"
                fixed></el-table-column>
            <el-table-column
                :class-name="mustFill(item)"
                v-for="(item, index) in columnsList"
                :key="index"
                :prop='item.prop'
                :label="item.label"
                :sortable="item.sort"
                :show-overflow-tooltip="_.get(item, 'show-overflow-tooltip', true)"
                :min-width="_.get(item, 'width', '')">
                <template slot-scope="scope">
                    <div style="display: flex;" v-if="scope.row.edit !== EDIT_TYPE.CANCEL && item.require">
                        <el-select
                            v-if="item.type === 'select'"
                            v-model="scope.row[item.prop]"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            :clearable="_.get(item, 'clearable',true)"
                            :filterable="item.filterable===undefined&&!item.multiple ? true : item.filterable"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            :multiple="_.get(item, 'multiple', false)"
                            :placeholder="item.name"
                            @change="(val) => elementChange(item.prop, val, scope.row, scope.$index)">
                            <el-option
                                v-for="(val, index) in _.get(scope.row, `${item.prop}Options`, item.options)"
                                :key=index
                                :label="val.label"
                                :value="val.value"
                                :disabled="val.disabled"
                            ></el-option>
                        </el-select>
                        <addressSelect
                            v-else-if="item.type === 'addressSelect'"
                            v-model="scope.row[item.prop]"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            :minLayers="_.get(scope.row, `${item.prop}Layers`,item.minLayers)"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            :basicProps="item.config"
                            @getAddress="labels => getAddress(scope.row, item, labels)"
                            @input="val => elementChange(item.prop, val, scope.row, scope.$index)"
                        ></addressSelect>
                        <addressCascader
                            v-else-if="item.type === 'addressCascader'"
                            v-model="scope.row[item.prop]"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            :minLayers="_.get(scope.row, `${item.prop}Layers`,item.minLayers)"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            :basicProps="item.config"
                            @getAddress="labels => getAddress(scope.row, item, labels)"
                            @input="val => elementChange(item.prop, val, scope.row, scope.$index)"
                            :hotData="item.hotData"
                            :showNoChoice="item.showNoChoice"
                            :draggable="item.draggable"
                        ></addressCascader>
                        <el-date-picker
                            style="width: 100%"
                            class='date-picker'
                            v-else-if="item.type === 'el-date-picker'"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            v-model="scope.row[item.prop]"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            size="mini"
                            :clearable="_.get(item, 'clearable', true)"
                            :format="item.format || 'yyyy-MM-dd HH:mm:ss'"
                            :value-format="item.format||'yyyy-MM-dd HH:mm:ss'"
                            :picker-options="item.pickerOptions||getOptions(item)"
                            :type="item.datePickerType || 'datetimerange'"
                            unlink-panels
                            :range-separator="$translate('component.E202007300014', { defaultText: '至' })"
                            :start-placeholder="item.startPlaceholder ? item.startPlaceholder : $translate('component.E202007300015', { defaultText: '开始日期' })"
                            :end-placeholder="item.endPlaceholder ? item.endPlaceholder : $translate('component.E202007300016', { defaultText: '结束日期' })"
                            :default-time="!item.datePickerType && ['00:00:00', '23:59:59']">
                        </el-date-picker>
                        <el-switch
                            class="demo"
                            v-else-if="item.type === 'switch'"
                            v-model="scope.row[item.prop]"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            :active-value="_.get(item, 'activeValue', 'Y')"
                            :inactive-value="_.get(item, 'inactiveValue', 'N')"
                            :active-text="item.statesY||tableConfig.statesY"
                            :inactive-text="item.statesN||tableConfig.statesN"
                            :width="item.switchWidth||40"
                            @change="(val) => elementChange(item.prop, val, scope.row, scope.$index)"
                        ></el-switch>
                        <el-input
                            readonly
                            v-else-if="item.type === 'advance'"
                            v-model="scope.row[item.prop]"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            @keyup.113.native="detailSearch(scope.$index, item.prop, item, scope.row[item.prop], scope.row)"
                            @keyup.enter.native="detailSearch(scope.$index, item.prop, item, scope.row[item.prop], scope.row)">
                            <el-button
                                slot="append"
                                icon="el-icon-search"
                                :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                                @click="detailSearch(scope.$index, item.prop, item, scope.row[item.prop], scope.row)"
                            ></el-button>
                            <i
                                slot="suffix"
                                class="el-input__icon el-icon-circle-close"
                                v-if="scope.row[item.prop]"
                                @click="resetAdvanceParams(item.prop, scope.row, scope.$index)"
                            ></i>
                        </el-input>
                        <div v-else-if='item.type === "detail"'>
                            <el-button size="mini" v-if="!scope.row[getEventName(item) + 'Hidden']" type='text'
                                @click.stop='btnEvent(scope.row, "edit" + getEventName(item))' @dblclick.stop="">
                                {{item.buttonName || $translate('component.E1202104121763', { defaultText: '明细' })}}
                            </el-button>
                        </div>
                        <el-input-number
                            v-else-if="item.type === 'inputNumber'"
                            v-model="scope.row[item.prop]"
                            :max="item.max === 0 ? 0 : (item.max || Infinity)"
                            :min="item.min === 0 ? 0 : (item.min || -Infinity)"
                            :step="item.step || 1"
                            :precision="item.precision || 0"
                            :step-strictly="item.stepStrictly || false"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            :controls="item.controls === undefined ? true : item.controls"
                            @change="(val) => elementChange(item.prop, val, scope.row, scope.$index)"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                        ></el-input-number>
                        <slot v-else-if="item.type === 'editSlot'" name="editSlot" v-bind="{ ...scope, col: item }"></slot>
                        <el-input
                            :clearable="_.get(item, 'clearable',true)"
                            v-else
                            :type="item.type || 'text'"
                            v-model="scope.row[item.prop]"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            @input="(val) => elementChange(item.prop, val, scope.row, scope.$index)"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                        ></el-input>
                    </div>
                    <div v-else-if='item.type === "photos"'>
                        <div v-if='scope.row.showPhotos' style="line-height: 0px;">
                            <img src="@/assets/photos.png" @click.stop='btnEvent(scope.row, "photos")' @dblclick.stop="" style="width: 20px; cursor: pointer;">
                        </div>
                        <div v-else-if="scope.row.noShowPhotos"></div>
                        <div v-else>
                            <el-button size="mini" type='text' @click.stop='btnEvent(scope.row, "upload")' @dblclick.stop="" v-if='item.ifHas' v-has='item.ifHas'>
                                {{$translate('component.E202007310005', { defaultText: '上传' })}}
                            </el-button>
                            <el-button size="mini" type='text' @click.stop='btnEvent(scope.row, "upload")' @dblclick.stop="" v-else>
                                {{$translate('component.E202007310005', { defaultText: '上传' })}}
                            </el-button>
                        </div>
                    </div>
                    <template v-else-if="item.type === 'custom'">
                        <slot name="customTableCell" v-bind="{ ...scope, col: item }" />
                    </template>
                    <template v-else>
                        <div v-if="item.type === 'switch'" @click="stopClick">
                            <el-switch
                                class="demo" v-model="scope.row[item.prop]"
                                disabled
                                :active-value="_.get(item, 'activeValue', 'Y')"
                                :inactive-value="_.get(item, 'inactiveValue', 'N')"
                                :active-text="item.statesY||tableConfig.statesY"
                                :inactive-text="item.statesN||tableConfig.statesN"
                                :width="item.switchWidth||40"
                            ></el-switch>
                        </div>
                        <div v-else-if="item.type === 'button'">
                            <el-button
                                type="text"
                                size="mini"
                                @contextmenu.prevent.native="$emit('btnRightClick', scope.row[item.prop], scope.$index, scope.row, item.prop)"
                                @click.stop="$emit('btnClick', scope.row[item.prop], scope.$index, scope.row, item.prop,item)">
                                {{ scope.row[item.prop] }}
                            </el-button>
                        </div>
                        <div v-else-if='item.type === "detail"'>
                            <el-button size="mini" v-if="!scope.row[getEventName(item) + 'Hidden']" type='text'
                                @click.stop='btnEvent(scope.row, getEventName(item))' @dblclick.stop="">
                                {{item.buttonName || $translate('component.E1202104121763', { defaultText: '明细' })}}
                            </el-button>
                        </div>
                        <div v-else-if='item.type === "el-date-picker"'>
                            <template v-if="item.datePickerType !== 'datetimerange'">
                                <div v-if="scope.row[item.prop]">
                                    {{ dayjs(scope.row[item.prop]).format(item.textFormat || 'YYYY-MM-DD HH:mm:ss') }}
                                </div>
                            </template>
                            <template v-else>
                                <div v-if="scope.row[item.prop]">
                                    {{dayjs(scope.row[item.prop][0]).format(item.textFormat || 'YYYY-MM-DD HH:mm:ss')}}
                                    {{ $translate('component.E202007300014', { defaultText: '至' }) }}
                                    {{dayjs(scope.row[item.prop][1]).format(item.textFormat || 'YYYY-MM-DD HH:mm:ss')}}
                                    }}
                                </div>
                            </template>
                        </div>
                        <template v-else>
                            {{item|initShow(scope.row)}}
                        </template>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                :label="$translate('component.E202006152352', { defaultText: '操作' })"
                fixed="right"
                v-if="tableConfig.leftOperation"
                :width="_.get(tableConfig, 'leftWidth', '')">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        :key="index"
                        :type=item.type
                        v-has='item.ifHas||""'
                        v-show="typeof item.show === 'function'? item.show(scope.row) : (item.show === false?false:true)"
                        v-for="(item, index) in tableConfig.action"
                        @click.stop=btnEvent(scope.row,item.event)>
                        {{item.event !== 'edit' ? item.label : (scope.row.edit !== EDIT_TYPE.CANCEL? $translate('component.E202006152345', { defaultText: '取消' }) : item.label)}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <advance-dialog ref="advanceDialog"></advance-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from '@/components/lots/utils';
import { dictWithUrl } from '@/components/lots/api';
import addressSelect from '@/components/lots/otpCascader2';
import addressCascader from '@/components/lots/addressCascader';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import dayjs from 'dayjs';
import { I18nMixins } from '@/components/utils/i18n';
import { hasPermission } from '@otp/utils/commonFun';
export default {
    name: 'mNewTable',
    mixins: [I18nMixins],
    data() {
        return {
            EDIT_TYPE: { EDIT: 2, CANCEL: -3 },
            selectedRowsData: [],
            errorList: [],
            columnsList: [],
            keyMap: {},
            pickerOptions: {
                shortcuts: [{
                    text: this.$translate('component.E202007300011', { defaultText: '最近一周' }),
                    onClick(picker) {
                        const start = new Date();
                        start.setHours(0);
                        start.setMinutes(0);
                        start.setSeconds(0);
                        start.setMilliseconds(0);
                        const end = new Date();
                        end.setHours(23);
                        end.setMinutes(59);
                        end.setSeconds(59);
                        end.setMilliseconds(0);
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$translate('component.E202007300013', { defaultText: '最近一个月' }),
                    onClick(picker) {
                        const start = new Date();
                        start.setHours(0);
                        start.setMinutes(0);
                        start.setSeconds(0);
                        start.setMilliseconds(0);
                        const end = new Date();
                        end.setHours(23);
                        end.setMinutes(59);
                        end.setSeconds(59);
                        end.setMilliseconds(0);
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            }
        };
    },
    props: {
        tableHeight: {
            type: Number,
            default: () => -1
        },
        tableConfig: Object,
        tableData: {
            type: Array
        },
        loading: {
            type: Boolean,
            default() {
                return true;
            }
        },
        tableList: {
            type: String,
            default() {
                return '';
            }
        },
        popPrefix: String,
        dictUrl: String,
        filterable: Boolean,
        columnsWidthConfig: Object
    },
    components: { addressSelect, advanceDialog, addressCascader },
    filters: {
        that: this,
        initShow(col, row) {
            if (row[col.prop] === 0) return 0;
            // 为空，为空数组时返回''
            if (!row[col.prop] || (_.isArray(row[col.prop]) && row[col.prop].length === 0)) {
                return '';
            }
            // 下拉框变为正常时显示值的改变
            let result = null;
            if (col.type === 'select') {
                if (_.isArray(row[col.prop])) {
                    result = row[col.prop].map(val => {
                        return _.get(col.options.find(item => item.value === val || item.label === val), 'label', '');
                    }).join(',');
                } else {
                    result = _.get(col.options && col.options.find(item => item.value === row[col.prop] || item.label === row[col.prop]), 'label', '');
                }
            } else if (col.type === 'addressSelect' || col.type === 'addressCascader') {
                result = row[col.labelCn];
            } else {
                result = row[col.prop];
            }
            return result || '';
        }
    },
    methods: {
        getSelection() {
            return this.$refs.moduleTable.selection;
        },
        tableRowClassName({ row }) {
            // row.defaultRowClass 默认高亮
            if ((this.selectedRowsData && this.selectedRowsData.map(item => item.id).includes(row.id)) || row.defaultRowClass) {
                return row.rowClass || 'highlight-row';
            }
        },
        _columnIfDisabled(row, col) {
            return _.isArray(row.disableProps) ? row.disableProps.includes(col.prop) : col.disabled;
        },
        clearSelection() {
            this.$refs.moduleTable.clearSelection();
        },
        selectionOne(checkedData) {
            this.$refs.moduleTable.toggleRowSelection(checkedData);
        },
        addRow() {
            // 新增一行，并进入行内编辑模式
            const obj = {};
            this.columnsList.forEach(item => {
                obj[item.prop] = item.defaultValue || '';
            });
            obj.edit = this.EDIT_TYPE.EDIT;
            this.tableData.unshift(obj);
            // 新增默认勾选
            this.$refs.moduleTable.toggleRowSelection(obj, true);
            // 新增返回值，用于手动修改新增的数据
            this.btnEvent(obj, 'addRowResponse');
        },
        elementChange(prop, val, row, index) {
            this.$emit('element-change', {
                prop,
                val,
                row,
                index
            });
        },
        stopClick() {
            event.stopPropagation();
        },
        getRowKeys(row) {
            return row.id;
        },
        handleSelectionChange(selection) {
            this.selectedRowsData = selection;
            this.$emit('onSelectionChange', selection);
        },
        rowDBclick(row) {
            if (this.tableConfig.clickModify === true) {
                return;
            }
            this.$emit('row-db-click', row);
        },
        btnEvent(selection, event) {
            if (event === 'edit') {
                // 状态取反
                selection.edit = ~selection.edit;
                if (selection.edit === this.EDIT_TYPE.CANCEL) {
                    this.$refs.moduleTable.toggleRowSelection(selection, false);
                    if (!selection.id) {
                        this.tableData.splice(selection.serialNum, 1);
                    } else if (selection.backup) {
                        this.$set(this.tableData, selection.serialNum, selection.backup);
                    }
                } else {
                    selection.backup = _.clone(selection);
                    this.$refs.moduleTable.toggleRowSelection(selection, true);
                }
            }
            this.$emit('btn-event', selection, event);
        },
        rowClick(rows) {
            // hasPermission
            const editItem = this.tableConfig.action.find(item => item.event === 'edit' && item.ifHas);
            /** 没有编辑权限 */
            const noEditPermission = editItem && !hasPermission(editItem.ifHas);
            if (noEditPermission) return;// 编辑按钮没有权限时,单击不可以编辑
            if (!this.tableConfig.clickModify || rows.edit === this.EDIT_TYPE.EDIT) {
                return;
            }
            this.tableData.forEach(item => {
                item.edit = this.EDIT_TYPE.CANCEL;
            });
            this.tableData[rows.serialNum].edit = this.EDIT_TYPE.EDIT;
            rows.backup = _.clone(rows);
            if (rows) {
                this.initRowBg(rows.serialNum);
                this.$refs.moduleTable.toggleRowSelection(rows, true);
            }
            this.$emit('row-click', rows);
        },
        // 提供给外部使用，验证表单字段
        saveData() {
            let ModifyData;
            if (!this.tableExamine(this.selectedRowsData)) {
                ModifyData = false;
            } else {
                ModifyData = this.selectedRowsData.map(item => {
                    delete item.backup;
                    return item;
                });
            }
            return ModifyData;
        },
        // 表格提交验证
        tableExamine(data) {
            let errorHint = false;
            let errorMsg = '';
            // 重置错误提醒对象
            this.errorList = this.tableData.map(item => {
                return Array(Object.keys(item).length).fill(false);
            });
            data.forEach(data => {
                this.columnsList.forEach((column, index) => {
                    const propIsNecessary = data.notNecessaryProps ? !data.notNecessaryProps.includes(column.prop) : column.mustFill;
                    if (propIsNecessary) {
                        if (data[column.prop] || data[column.prop] === 0) {
                            if (_.isArray(data[column.prop]) && data[column.prop].length === 0) {
                                this.errorList[data.serialNum][index] = errorHint = true;
                                errorMsg = this.$translate('component.E202011260008', { defaultText: '必填项不能为空' });
                            } else if (column.verify && !RegExp(column.verify).test(data[column.prop])) {
                                this.errorList[data.serialNum][index] = errorHint = true;
                                errorMsg = this.$translate('component.E202011260009', { defaultText: column.verifyErrorMsg ? column.verifyErrorMsg : '部分选项格式不正确' });
                            }
                            data.edit = this.EDIT_TYPE.EDIT;
                        } else {
                            this.errorList[data.serialNum][index] = errorHint = true;
                            errorMsg = this.$translate('component.E202011260008', { defaultText: '必填项不能为空' });
                            data.edit = this.EDIT_TYPE.EDIT;
                        }
                    }
                });
            });
            if (errorHint) {
                this.$message.error(errorMsg);
            } else {
            }
            return !errorHint;
        },
        // 重新配置列宽度
        resetColumnWidth(columnsList) {
            this.columnsWidthConfig && Object.keys(this.columnsWidthConfig).forEach(key => {
                const col = columnsList.find(e => e.prop === key);
                if (col) {
                    col.width = this.columnsWidthConfig[key];
                }
            });
            return columnsList;
        },
        // 下拉框字典查询
        getOptionList(columnsList) {
            const optionList = [];
            const numList = [];
            columnsList.forEach((columns, index) => {
                if (columns.optionNum) {
                    optionList.push(columns.optionNum);
                    numList.push(index);
                }
            });
            if (optionList.length !== 0) {
                const params = {
                    dictCodes: optionList.join(','),
                    tenantCode: this.currentTenant.tenantCode
                };

                dictWithUrl(params, this.dictUrl).then(list => {
                    const optiondata = optionList.map(num => {
                        const option = [];
                        for (const key in list.data[num]) {
                            if (list.data[num].hasOwnProperty(key)) {
                                option.push({ 'value': key, 'label': _.get(list, `data.${num}.${key}`, '') });
                            }
                        }
                        return option;
                    });
                    numList.map((data, index) => {
                        columnsList[data].options = optiondata[index];
                    });
                });
            }
            this.columnsList = this.resetColumnWidth(columnsList);
        },
        detailSearch(index, prop, item, searchData, row) {
            if (!searchData) {
                searchData = '';
            }
            //  当前操作的行index
            index = this.tableData.findIndex(i => i === row);
            const advanceCascade = {};
            // 高级搜索级联操作，current.advanceCascade为需要级联的参数的key的集合，例如advanceCascade: key1,key2,key3
            if (item && _.isString(item.advanceCascade)) {
                let advanceArray = [];
                advanceArray = item.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = row[sourceProp];
                });
            }
            // advanceRequire 作某个联动值的空值校验[{ 'prop': 'xxx', 'message': 'xxx' }]，prop为联动值字段，message为空值时输出信息
            const { mode, advanceRequire } = item;
            if (advanceRequire && advanceRequire.length > 0) {
                let flag = true;
                advanceRequire.forEach(ad => {
                    if (!row[ad.prop]) {
                        flag = false;
                        this.$message.warning(ad.message);
                    }
                });
                if (!flag) { return false; }
            }
            this.$refs.advanceDialog.show(true, item, advanceCascade, mode);
            this.$refs.advanceDialog.$once('confirm', (result) => {
                // 将返回数据添加到map里，用于高级搜索清空时，顺带清空其他关联属性
                const keyArr = Object.keys(result);
                if (keyArr.length > 0) {
                    keyArr.forEach(key => {
                        this.keyMap[key] = keyArr;
                    });
                }
                Object.assign(row, result);
                this.$emit('element-change', { val: _.clone(result), type: 'advance', row, prop, index });
            });
        },
        dataInit(tableData) {
            const list = tableData || this.tableData;
            list.map((item, index) => {
                item.serialNum = index;
                if (item.id) {
                    this.$set(this.tableData[index], 'edit', this.EDIT_TYPE.CANCEL);
                }
                const errList = [];
                for (let i = 0; i < Object.keys(item).length; i++) {
                    errList.push(false);
                }
                this.$set(this.errorList, index, errList);
            });
            // 初始化keyMap
            this.columnsList.forEach(data => {
                if (data.type === 'advance' && _.isArray(data.cbParams)) {
                    const keys = data.cbParams.map(item => {
                        const arr = item.split('#');
                        return arr[1] || arr[0];
                    });
                    keys.forEach(key => {
                        this.keyMap[key] = keys;
                    });
                }
            });
            this.initRowBg();
        },
        // 初始化行背景，并高亮指定行
        initRowBg(rowIndex = null) {
            const arr = document.getElementsByClassName('el-table__row');
            for (let i = 0; i < arr.length; i++) {
                arr[i].style.background = '';
            }
            if (rowIndex) {
                arr[rowIndex].style.background = '#F1F8FA';
            }
            return arr;
        },
        // 转化中文地址数组成连续字符串
        getAddress(row, item, labels) {
            row[item.labelCn] = labels.join(' / ');
        },
        // 高级输入框的关闭按钮点击
        resetAdvanceParams(prop, row, index) {
            const keyArr = this.keyMap[prop];
            // 把属性相关联的字段置空
            _.isArray(keyArr) && keyArr.forEach(key => {
                row[key] = '';
            });
            this.elementChange(prop, '', row, index);
        },
        headerDragendHandler(newWidth, oldWidth, column, event) {
            this.$emit('header-dragend', { width: newWidth, property: column.property });
        }
    },
    watch: {
        tableData: function (val) {
            this.dataInit(val);
        },
        tableList: function (list) {
            const datas = list.split(',');
            const columnsList = [];
            datas.forEach(title => {
                this.tableConfig.columns.forEach(data => {
                    if (data.label === title) {
                        columnsList.push(data);
                    }
                });
            });
            this.getOptionList(columnsList);
        }
    },
    computed: {
        getOptions() {
            return item => {
                const optionType = item.datePickerType || 'datetimerange';
                const options = {
                    datetimerange: this.pickerOptions
                };
                return options[optionType] || {};
            };
        },
        dayjs() {
            return dayjs;
        },
        ...mapGetters(['currentTenant']),
        _() {
            return _;
        },
        mustFill() {
            return (item) => {
                return item.mustFill ? 'column-must-fill' : '';
            };
        },
        getEventName() {
            return item => item.emitEvent || 'detail';
        }
    }
};
</script>
<style lang="less">
.otp-inline-table {
    height: 100%;
    &.opt-table-with-table-height {
        .el-table {
            min-height: unset!important;;
            max-height: unset!important;
        }
        .el-table__body-wrapper {
            min-height: calc(100% - 36px);
            max-height: calc(100% - 36px);
        }
    }

    .module-table {
        margin: 12px 0;
    }

    .el-table__body tr.selected-row > td {
        background: #F1F8FA !important;
    }
    .el-table__body tr.highlight-row {
        background: #e6f8f9;
    }

    .error-active input {
        border-color: red;
    }

    .error-active.date-picker {
        border-color: red;
    }

    .error-active .otpAllAddressSelect .el-cascader .el-input {
        border-color: red;
    }

    .demo .el-switch__label {
        position: absolute;
        display: none;
        color: #fff;
    }

    /*打开时文字位置设置*/

    .demo .el-switch__label--right {
        z-index: 1;
        right: -10px;
    }

    /*关闭时文字位置设置*/

    .demo .el-switch__label--left {
        z-index: 1;
        left: 26px;
    }

    /*显示文字*/

    .demo .el-switch__label.is-active {
        display: block;
    }

    .demo.el-switch .el-switch__core,
    .el-switch .el-switch__label {
        width: 60px !important;
    }

    .el-button--text {
        padding: 7px 0;
    }

    .has-gutter .column-must-fill {
        > div.cell::after {
            content: '*';
            color: red;
            font-size: 16px;
            margin-left: 5px;
        }
    }
}
</style>
